/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IPaginatedDataEF_Response, IProtocolloAreaDiLavoro, IQueryCriteriaEF } from "../shared/interfaces";


const controller = 'AreaDiLavoro';


const getProtocolliAreaDiLavoro = (uorId: number, queryCriteria: IQueryCriteriaEF, cancelToken?: CancelToken): Promise<IPaginatedDataEF_Response> => {
    return axiosInstance.post(`${controller}/GetProtocolliAreaDiLavoro/${uorId}`, queryCriteria, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocolloAreaDiLavoro = (uorId: number, protocolSPId, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.get(`${controller}/GetProtocolloAreaDiLavoro/${uorId}/${protocolSPId}`, { cancelToken: cancelToken })
        .then(result => {
            if (result.status === 204) {
                return undefined;
            }
            return result.data
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


const updateProtocolloAreaDiLavoro = (modifiedItem: IProtocolloAreaDiLavoro, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.put(`${controller}/Update`, modifiedItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const patchProtocolloAreaDiLavoro = (uorId: number, protocolSPId: number, patchDocument: any, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.patch(`${controller}/Patch/${uorId}/${protocolSPId}`, patchDocument, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addProtocolloAreaDiLavoro = (protocolSPId: number, newItem: Partial<IProtocolloAreaDiLavoro>, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.post(`${controller}/Add/${protocolSPId}`, newItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}






const avviaLavorazioneEPendiInCarico = (modifiedItem: IProtocolloAreaDiLavoro, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.put(`${controller}/AvviaLavorazioneEPendiInCarico`, modifiedItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const avviaLavorazione = (modifiedItem: IProtocolloAreaDiLavoro, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.put(`${controller}/AvviaLavorazione`, modifiedItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const pendiInCarico = (modifiedItem: IProtocolloAreaDiLavoro, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.put(`${controller}/PendiInCarico`, modifiedItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const terminaLavorazione = (modifiedItem: IProtocolloAreaDiLavoro, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.put(`${controller}/TerminaLavorazione`, modifiedItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const ripristinaLavorazione = (modifiedItem: IProtocolloAreaDiLavoro, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.put(`${controller}/RipristinaLavorazione`, modifiedItem, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getProtocolliAreaDiLavoro,
    getProtocolloAreaDiLavoro,
    updateProtocolloAreaDiLavoro,
    patchProtocolloAreaDiLavoro,
    addProtocolloAreaDiLavoro,
    avviaLavorazioneEPendiInCarico,
    avviaLavorazione,
    pendiInCarico,
    terminaLavorazione,
    ripristinaLavorazione
}